import { render, staticRenderFns } from "./UnreadFinancialBatchesStrip.vue?vue&type=template&id=6efb8b68"
import script from "./UnreadFinancialBatchesStrip.vue?vue&type=script&lang=js"
export * from "./UnreadFinancialBatchesStrip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports